/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
    baseStyle: {
        subscribeMainBlock: {
            borderRadius: 'lg',
            my: {base: '6', md: '8'},
            display: {base: 'block', md: 'flex'},
            backgroundSize: 'cover'
        },
        subscribeText: {
            fontSize: '2xl',
            fontWeight: 'extrabold',
            lineHeight: 8,
            marginBottom: 2
        },
        subscribeBtn: {
            borderRadius: 'full',
            backgroundColor: 'black',
            textTransform: 'none',
            minWidth: '180px',
            width: {base: '100%', md: 'auto'},
            borderColor: 'black',
            color: 'white',
            _hover: {
                backgroundColor: '#3e3e3e'
            }
        },
        subscribeCalloutImg: {
            flex: {base: 1},
            borderRadius: {base: '0 0 8px 8px', md: '0 8px 8px 0'},
            backgroundPosition: 'center',
            clipPath: {
                base: 'polygon(0 0, 100% 25px, 100% 100%, 0% 100%)',
                md: 'polygon(6% 0, 100% 0, 100% 100%, 0% 100%)'
            },
            height: {base: '180px', md: 'auto'}
        }
    },
    parts: ['subscribeMainBlock', 'subscribeBtn', 'subscribeText', 'subscribeCalloutImg']
}
